<template>
<LayoutContainer columns="30/70">
<v-toolbar slot="header" dark dense class="primary no-print">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>home</v-icon>
    </v-btn>
    <v-toolbar-title>{{pageTitle}}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" dark icon @click="showEmail">
            <v-icon>email</v-icon>
        </v-btn>
        </template>
        <span>Email Client</span>
    </v-tooltip>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" dark icon @click="goToTransaction">
            <v-icon>ballot</v-icon>
        </v-btn>
        </template>
        <span>Go to Transaction</span>
    </v-tooltip>

    <v-menu bottom left :nudge-width="200">
        <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" dark>
            <v-icon>more_vert</v-icon>
        </v-btn>
        </template>
        <v-list>            
            <v-list-item @click="goToTransaction"> 
                <v-list-item-title>Go to Transaction</v-list-item-title>
            </v-list-item>            
            <v-list-item @click="">
                <LinkNewTab :link="'/client-checklist/' + checklistKey">
                <v-list-item-title>Go to Client View</v-list-item-title>
                </LinkNewTab>
            </v-list-item>            
            <v-list-item @click="goToTemplates"> 
                <v-list-item-title>Go to Templates</v-list-item-title>
            </v-list-item>            
            <v-list-item @click="goToOldChecklist"> 
                <v-list-item-title>Go to Old Checklist</v-list-item-title>
            </v-list-item>            
            <v-list-item @click="goToOldChecklist"> 
                <v-list-item-title>Go to Old Checklist</v-list-item-title>
            </v-list-item>            
            <v-list-item v-if="!isMobile" @click="downloadAllFiles"> 
                <v-list-item-title>Download All Files (Zip)</v-list-item-title>
            </v-list-item>            
        </v-list>
    </v-menu>
    
</v-toolbar>

<div slot="col1" class="no-print">

    <ChecklistMenu :menu="menu"
        @click="checklistMenuClicked" 
        @add="addDocumentForCategory"
    />

</div> 


<!-- ******************  Middle Column ****************************** -->

<div slot="col2">

    <v-row wrap style="height:100%">
        <v-col xs12 sm12 md7 lg8 class="taco-column">  <!--Inner left column-->

            <div class="pa-3">
                <NoRecordsPlaceholder v-if="!checklistSummary.documents">
                    No items.<br/>
                    Choose one or more templates --><br/>
                    <-- Select items from the menu
                </NoRecordsPlaceholder>
                
                <!-- <div v-if="detailsVisible">
                    <div class="section vertical-margin">Checklist Details</div>
                    <AdvancedPanel :fields="checklistDetailsPanel.fields" :record="checklistDetails" :recordRef="listRef" 
                        @button="checklistDetailsButtonClicked" @field-change="checklistDetailsFieldChanged" />
                </div> -->


                <div>
                    <ChecklistDetails ref="checklistDetails" :transactionKey="transactionKey" :checklistKey="checklistKey" :mode="checklistDetailsMode" :pageSettings="pageSettings" @add-category-document="addDocumentForCategory" />
                    <div style="display:none;background-color:yellow;">
                        <ChecklistDetails ref="checklistHidden" :transactionKey="transactionKey" :checklistKey="checklistKey" mode="Email" :pageSettings="pageSettings" />
                    </div>
                </div>

                <!-- Clipboard button -->

                <v-tooltip right class="no-print">
                    <template v-slot:activator="{ on }">
                    <v-btn v-if="selectedItems.length" v-on="on" icon color="grey lighten-1" @click.native="copyToClipboard" >
                        <v-icon color="white">assignment_turned_in</v-icon>
                    </v-btn> 
                    </template>
                    <span>Copy to Clipboard</span>  
                </v-tooltip>
                <v-tooltip right class="no-print">
                    <template v-slot:activator="{ on }">
                    <v-btn v-if="selectedItems.length" v-on="on" icon color="grey lighten-1" @click.native="showEmail" >
                        <v-icon color="white">email</v-icon>
                    </v-btn> 
                    </template>
                    <span>Email to Client</span>  
                </v-tooltip>
                <br/>

                <!-- This is maybe something to try later... <img src="https://image-charts.com/chart?cht=p&chd=t:1,2,4&chs=300x150&chdl=Complete|Pending|Outstanding&chco=42A5F5|F57C00|D32F2F" /> -->

            </div>
                    
        </v-col>

        <!-- Right hand column -->

        <v-col xxxxv-if="transactionKey" xs12 sm12 md5 lg4 class="pa-3 no-print" style="background-color:#eee;border-radius:8px" row>
            <div class="section-heading">Templates</div>
                    <AdvancedPanel :fields="checklistDetailsPanel.fields" :record="checklistDetails" :recordRef="listRef" 
                         @field-change="checklistDetailsFieldChanged" />
                        <!-- @button="checklistDetailsButtonClicked" -->
            <div class="section-heading vertical-margin">Next Followup</div>
            {{followUpTask.due | dueString}}
            <Scheduler v-model="followUpTask.due" @change="saveFollowupTask" />
            <div class="mt-2">

            <UserChooser v-model="followUpTask.assigned" label="Assigned To" @select="saveFollowupTask"/>
            </div>

            <div class="section-heading mt-4 mb-2">Checklist Comments</div>

            <TransactionComments/>
            <!-- Not really needed? <ContactCard v-for="(contact, index) in clients" :contact="contact" :key="index"/> -->
           
        </v-col>
    </v-row>
</div>

<!--Dialog-->

<template slot="dialogs">

    <EmailDialog :settings="emailDialog.settings" :email="emailDialog.email" :returnObject="emailDialog.returnObject"/>
    <!-- <SupplierDocumentDialog :settings="supplierDocumentDialog.settings" :document="supplierDocumentDialog.document" @save="saveDocument" /> -->
    <AdvancedDialog :record="addDocumentDialog.record" :settings="addDocumentDialog.settings" :fields="addDocumentDialog.fields" @save="saveDocumentForCategory" />

</template> 



</LayoutContainer>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
//
import clipboard from 'clipboard-js'
import FirebaseHelpers from '@/helpers/FirebaseHelpers'
import ContactHelpers from '@/helpers/ContactHelpers'
import ElementHelpers from '@/helpers/ElementHelpers'
import StringHelpers from '../../helpers/StringHelpers'
import DataHelpers from '../../helpers/DataHelpers'
import AlertHelpers from '@/helpers/AlertHelpers'
import Scheduler from '@/ui-elements/Scheduler'
import UserChooser from '@/ui-elements/UserChooser'
import TransactionComments from '@/ui-elements/TransactionComments'
// import email from '@ui-elements/email'
import Utilities from '@/helpers/Utilities'
import FireData from '@/data/FireData'
import EmailDialog from '@/ui-elements/EmailDialog'
// import SupplierDocumentDialog from './SupplierDocumentDialog'
import ChecklistMenu from './ChecklistMenu'
import NiceData from '../../data/NiceData'
import ChecklistItems from './ChecklistItems'
import ChecklistDetails from './ChecklistDetails'
import AdvancedList from '../../ui-elements/AdvancedList'
import AdvancedPanel from '../../ui-elements/AdvancedPanel'
import AdvancedDialog from '../../ui-elements/AdvancedDialog'
import OrderHelpers from '../../helpers/OrderHelpers'
import ContactCard from '../../ui-elements/ContactCard'
import LinkNewTab from '../../ui-elements/LinkNewTab'
import NoRecordsPlaceholder from '../../ui-elements/NoRecordsPlaceholder'
import PageHelpers from '../../helpers/PageHelpers'
import ArrayHelpers from '../../helpers/ArrayHelpers'
import ChecklistHelpers from './ChecklistHelpers'
import FileHelpers from '../../helpers/FileHelpers'
import JSZip from 'jszip'
import saveAs from 'file-saver'
import { differenceInDays } from 'date-fns';
import { addDays } from 'date-fns/fp';
import { dateFormats } from '../../helpers/DateHelpers'


export default {
    name: 'DocumentChecklist',
    props: {
            tenantKey: String,
            transactionKey: String,
            checklistKey: String
    }, 

    components: {
        LayoutContainer,
        // SupplierDocumentDialog,
        Scheduler,
        UserChooser,
        EmailDialog,
        TransactionComments,
        ChecklistMenu,
        ChecklistItems,
        ChecklistDetails,
        AdvancedList,
        AdvancedPanel,
        AdvancedDialog,
        ContactCard,
        LinkNewTab,
        NoRecordsPlaceholder,
    },
    data() {
        return {
            detailsVisible: false,
            leftColumnTabs: null,
            //editMode: false,
            // templateKeys: ['123456789'],
            menu: {categories:{}},

            checklistDetails: {},
            checklistDetailsMode: 'Consultant',

            dialogTab: 0,
            followUpTask: {
                code: 'document-checklist',
                title: 'Follow up document checklist',
                due: null,
                assigned:null,
                transactionKey: this.transactionKey
            },

            transactionFields: [],
            
            search: '',
            selectedItems: [],
            activeItem: '',
            lender: 'General',
            newCheckItem: '',
            liveTransaction: {
                details:{}
            },
            
            //dialog items

            dialogVisible: false,
            dialogDateMenu: false,
            documentKey: '',
            
            documentName: '',
            documentDescription: '',
            documentDownload: '',
            documentImportance: 0,
            documentInstructions:'',
            documentReceived: false,
            documentChecked: false,
            documentChecklist: [],
            documentDate: null,
            documentExpiryDays: null,
            documentFlag: '',
            documentNote: '',

            emailDialog: {
                  email: {
                        to: null,
                        cc: null,
                        bcc: null,
                        subject: null,
                        body: '',
                    },
                    settings: {
                        visible: false,
                        customFields: {
                            checklist: null
                        }
                    },
                    returnObject: null,
            },

            newActivity: null,

            checklistTable: {
                ref: null,
                fields: [
                    {name: 'name', type: 'Text'},
                    {name: 'templates', type: 'List'},
                    {name: 'template', type: 'Switch',},
                    {name: 'global', type: 'Switch'},
                    {name: 'stamp', type: 'Text', default: '[stamp]'},
                    {name: 'tenantKey', type: 'Text', default: '[tenantKey]'},
                ],
            },

            checklistDetailsPanel: {
                fields: [
                    // {name: 'name', title: 'Client Name/s', type: 'Text'},
                    {name: 'templates', title: 'Templates', type: 'List', multiple:true, returnObject:true, options:[]}, //options loaded in created
                    {name: 'flagOutstandings', title: 'Flag Outstanding Docs', type: 'Switch'},
                    // {name: 'doneButton', title: 'Done', type: 'Button', width:50}
                ],
                settings: {},
            },

            addDocumentDialog: {
                record: {},
                settings: {
                    visible: false
                },
                fields: [], 
            },

            addDocumentFields: [
                {name: 'name', title: 'Name', type: 'Text', focus: true},
                {name: 'checks', title: 'Things to Check', type: 'Group', fields: [
                    {name: 'check', title: 'Please Check', type: 'Text', width:70},
                ]},
            ],
            
        }
    },

    // firebase: {
    //         lenders: lendersRef,
    //         categories: categoriesRef,
    //         requirements: requirementsRef,
    //         requests: requestsRef,
    //         generalRequests: generalRequestsRef,
    // }, 
    watch: {
        selectedItems: function() {
            this.updateProgress()
        }
    },       
    computed: {
        
        checklistSummary() {
            return PageHelpers.getPageData('summary') || {}
        },

        clientUrl() {
            return StringHelpers.rootPath() + 'client-checklist/' + this.checklistKey
        },

        clientLink() {
            //return '<a href="' + this.clientUrl + '" target="_blank">Go to Checklist</a>'
            return StringHelpers.linkToTaco('client-checklist/' + this.checklistKey, 'Go to Checklist')
        },

        pageSettings() {
            return {
                flagOutstandings: this.checklistDetails.flagOutstandings
            }
        },

        pageTitle() {
            if(this.clients)    
                return ContactHelpers.combineClientsNames(this.clients)

            return 'Document Checklist'
        },

        topRef() {
            return DataHelpers.getRootRef().child('app/documentChecklist')
        },

        listRef() {
            return this.topRef.child('list').child(this.checklistKey)
        },

        dataRef() {
            return this.topRef.child('data').child(this.checklistKey)
        },

        clients () {
            if(this.liveTransaction.clients && this.liveTransaction.clients.length)
                return this.liveTransaction.clients 

            if(this.checklistDetails.name)
                return ContactHelpers.namesToContacts(this.checklistDetails.name)
  
            return []
        },

        recipients () {
            return this.clients.filter(o => o.email).map(o => {
                let recipient = {...o}
                recipient.role = 'Client'
                recipient.fullName = ContactHelpers.fullName(recipient)
                recipient.fullNameAndEmail = ContactHelpers.fullName(recipient) + '(' + recipient.email + ')'
                return recipient
            })
        },
      
        checklistRef() {
            if(this.transactionKey)
                return DataHelpers.getTenantRef().child('transactions').child(this.transactionKey).child('checklist')
            else
                return null
        },

        documentDateString: function () {
            if(this.documentDate) {
                console.log('calcing date')
                return format(DateHelpers.backwardsToDate(this.documentDate), DateFormats.AUSTRALIAN)
                // return moment(this.documentDate).format('DD/MM/YY')
            } else    
                return ''
        },

        selectedPolicies() {
            return this.$store.getters.getSelectedKeys('checklist-policies')
        },

        isMobile () {
            return Utilities.isMobile()
        },

    },  
    methods: {

        downloadAllFiles() {
            let ref = this.dataRef.child('documents')
            NiceData.fetchItemsFromFirebase(ref).then(documents => {
                let attachments = []
                let documentsWithAttachments = documents.filter(d => d.attachment)

                //fetch the category for each document...
                let allPromises = []
                documentsWithAttachments.forEach(document => {
                    let p = ChecklistHelpers.fetchPolicyForDocument(document).then(policy => {
                        document.category = policy.category
                    })
                    allPromises.push(p)
                })
                Promise.all(allPromises).then(result => {
                    documentsWithAttachments.forEach(document => {
                        document.attachment.forEach(file => {
                            attachments.push({
                                url: file.url,
                                category: document.category,
                            })
                        })
                    })
                    console.log(attachments)
                    this.saveToZip('checklist_documents.zip', attachments)
                })
            })
        },  

        saveToZip (filename, attachments) {
            
            AlertHelpers.showAlert('Downloading...See below')
            const zip = new JSZip()
            
            attachments.forEach((attachment)=> {
                const blobPromise = fetch(attachment.url).then(r => {
                    if (r.status === 200) return r.blob()
                    return Promise.reject(new Error(r.statusText))
                })
                const folder = zip.folder(attachment.category)
                const name = FileHelpers.fileNameFromStoragePath(attachment.url)
                folder.file(name, blobPromise)
            })

            zip.generateAsync({type:"blob"})
                .then(blob => {
                    saveAs(blob, filename)
                }).catch(e => console.log(e))
        },                

        isSelected(policyName) {
            return Boolean(this.selectedPolicies.find(p => p == policyName))
        },

        checklistDetailsFieldChanged(changes) {
            if(changes.name == 'templates')
                this.loadMenu()
        },
        // checklistDetailsButtonClicked(buttonName, record) {
        //     if(buttonName == 'doneButton') {
        //         this.detailsVisible = false
        //     }
        // },
        categoryClicked(category) {
            //let categoryName = category.name
            
        },

        addDocumentForCategory(category) {
            console.log('addDocumentForCategory', category)
            this.addDocumentDialog.fields = this.addDocumentFields
            this.addDocumentDialog.record = {
                categoryName: category.name,
                categoryOrder: category.order,
                categoryKey: category.meta.key
            }
            this.addDocumentDialog.settings.title = 'Add ' + category.name + ' document'
            this.addDocumentDialog.settings.visible = true
        },

        //For new ad-hoc documents
        saveDocumentForCategory(documentDetails) {
            console.log('saveDocumentForCategory', documentDetails)
            
            let ref = this.dataRef.child('categories')
            NiceData.fetchItemByName(ref, documentDetails.categoryName).then(category => {
                if(!category) {
                    category = {
                        meta: {
                            key: documentDetails.categoryKey, 
                            path: NiceData.firebaseRefToPath( this.dataRef + '/categories' )
                        },
                        name: documentDetails.categoryName,
                        order: documentDetails.categoryOrder,
                    }
                }
                NiceData.saveItem(category)
            })
             
            let policy = {
                meta: {
                    key: DataHelpers.getKey(), 
                    path: NiceData.firebaseRefToPath( this.dataRef + '/policies' )
                },
                name: documentDetails.name,
                category: documentDetails.categoryName
            }
            NiceData.saveItem(policy)

            let option = {
                meta: {
                    key: DataHelpers.getKey(), 
                    path: NiceData.firebaseRefToPath( this.dataRef + '/options' )
                },
                name: documentDetails.name,
                policyKey: policy.meta.key,
                preferred: true,
            }
            NiceData.saveItem(option)
            
            let document = {
                meta: {
                    key: DataHelpers.getKey(), 
                    path: NiceData.firebaseRefToPath( this.dataRef + '/documents' )
                },
                name: documentDetails.name,
                optionKey: option.meta.key,
                checks: documentDetails.checks || null,
            }
            NiceData.saveItem(document)
        },
        
        //for documents added from menu...
        checklistMenuClicked(policy) {
            let ref = this.dataRef.child('policies')
            NiceData.fetchItemByName(ref, policy.name).then(localPolicy => {
                if(localPolicy) {
                    if(!localPolicy.modified)
                        ChecklistHelpers.deletePolicyCascade(localPolicy)
                    else {
                        this.$root.$confirm('Delete', 'Are you sure you want to delete this policy?', { color: 'red' }).then(res => {
                            if(res)
                                ChecklistHelpers.deletePolicyCascade(localPolicy)
                        })
                    }
                    return
                }
                this.importPolicy(policy)  
            })
        },

        importPolicy(policy) {
            this.detailsVisible = false
            
            let checklistTopPath = NiceData.firebaseRefToPath(this.dataRef)
            let templateKey = policy.meta.path.split('/')[3]
            let templateTopRef = this.topRef.child('data').child(templateKey)

            console.log('**** policy path is ', policy.meta.path)


            // Save Policy
            
            let newPolicy = JSON.parse(JSON.stringify(policy))
            newPolicy.meta.path = checklistTopPath + '/policies'

            NiceData.saveItem(newPolicy)

            // Save Category
            let categorySourceRef = templateTopRef.child('categories').orderByChild('name').equalTo(policy.category)
            let existingCategoryRef = this.dataRef.child('categories').orderByChild('name').equalTo(policy.category)
            NiceData.fetchItemsFromFirebase(existingCategoryRef).then(categories => {
                if(categories.length < 1) {
                    NiceData.fetchItemsFromFirebase(categorySourceRef).then(categories => {
                        if(categories.length < 1) {     
                            console.error('no categories')
                            debugger
                        } else {
                            let newCategory = {...categories[0]}
                            newCategory.meta.path = checklistTopPath + '/categories'
                            NiceData.saveItem(newCategory)                            
                        }
                    })
                } else {
                    let newCategory = {...categories[0]}
                    newCategory.meta.path = checklistTopPath + '/categories'
                    NiceData.saveItem(newCategory)
                }
            })

            //Save Options
            let optionSourceRef = templateTopRef.child('options').orderByChild('policyKey').equalTo(policy.meta.key)
            NiceData.fetchItemsFromFirebase(optionSourceRef).then(options => {
                options.forEach(option => {
                    let newOption = {...option}
                    newOption.meta.path = checklistTopPath + '/options'
                    NiceData.saveItem(newOption)

                    //Save Documents
                    let documentSourceRef = templateTopRef.child('documents').orderByChild('optionKey').equalTo(option.meta.key)
                    NiceData.fetchItemsFromFirebase(documentSourceRef).then(documents => {
                        documents.forEach(document => {
                            let newDocument = {...document}
                            newDocument.meta.path = checklistTopPath + '/documents'
                            NiceData.saveItem(newDocument)
                        })
                    })

                })
            })
        },
      
        goToTransaction() {
            this.$router.push('/' + this.tenantKey + '/transaction/' + this.checklistKey)
        },
        goToTemplates() {
            this.$router.push('/' + this.tenantKey + '/checklist-templates')
        },
        goToOldChecklist() {
            this.$router.push('/' + this.tenantKey + '/supplier-checklist/' + this.checklistKey)
        },

        stamp(activity) {
            let stampString = DataHelpers.formatStamp(activity.stamp)
            return stampString
        },            

        showEmail () {
            Utilities.log('showEmail')
           
            this.emailDialog.email.to = this.recipients
            this.emailDialog.settings.group = 'Checklist'
            this.emailDialog.settings.template = 'Followup'
            this.emailDialog.returnObject = null
            //reach into checklist details component and grab html for checklist...
            let html = this.$refs.checklistHidden.$refs.checklist.innerHTML
            this.emailDialog.settings.customFields.checklist = html
            this.emailDialog.settings.customFields.client_link = this.clientLink

            this.emailDialog.settings.visible = true  
  

        },

        //need this later?
        documentExpired (doc) {
            
            if(!doc.expiryDays)
                doc.expiryDays = 30
                // return ''
            
            //let expiryMoment = moment(doc.documentDate, "YYYY-MM-DD").add(doc.expiryDays, 'days')
            const expiryDate = addDays(DateHelpers.backwardsToDate(doc.documentDate), doc.expiryDays)

            let days = addDays(new Date(), expiryDate)
            
            if(days < 7)
                if(days > 0)
                    return 'Expires ' +  days + 'd'
                else if(days == 0)
                    return 'Expired Today'
                else
                    return 'Expired ' + Math.abs(days) + 'd ago'
            else
                return ''
        },

        getTransactionRef () {
            return this.getTenantRef().child('transactions/' + this.checklistKey)
        },
        
        copyToClipboard () {

            let html = this.$refs.checklist.innerHTML
            
            clipboard.copy({'text/html': html})
            
            AlertHelpers.showAlert('Copied to clipboard')
        },

        saveFollowupTask() {
            console.log('saveFollowupTask', this.followUpTask)
            this.$store.dispatch('saveTask', this.followUpTask)
        },

        setSpecialTab(name) {
            const tab = {
                key: name,
                title: StringHelpers.capitalizeFirstLetter(name),
                name: name,
                type: 'Tab'
            }
            this.$store.commit('setSelectedTab', tab)
        },          

        loadDetails() {
            let vm = this
            return new Promise( (resolve, reject) => {
              
                // resolve({})
                // return 
                vm.ref = DataHelpers.getRootRef().child('app/documentChecklist/list')
                      
                //let ref = this.checklistTable.ref.child(this.checklistKey)
                let ref = DataHelpers.getRootRef().child('app/documentChecklist/list').child(this.checklistKey)
                NiceData.fetchItemSingle(ref).then( (item) => {
                    if(item)
                        this.checklistDetails = item
                    else {
                        this.checklistTable.ref = DataHelpers.getRootRef().child('app/documentChecklist/list')
                        this.checklistDetails = NiceData.makeRecord(this.checklistTable)
                        this.checklistDetails.meta.key = this.checklistKey
                        NiceData.saveItem(this.checklistDetails)
                    }
                    resolve(item)
                })
                        
            })
        
        },

        loadMenu() {
            if(!this.checklistDetails || !this.checklistDetails.templates)
                return
            this.menu = {}
                
            let templates = [...this.checklistDetails.templates].sort(OrderHelpers.sortByOrder)
            templates.reverse()
            templates.forEach(template => {

                let ref = DataHelpers.getRootRef().child('app/documentChecklist/data/' + template.value)
                NiceData.fetchItemsFromFirebase(ref.child('categories')).then(categories => {
                    
                    categories.forEach(category => {
                        this.$set(this.menu, 'categories', this.menu.categories || {})
                        this.$set(this.menu.categories, category.name, this.menu[category.name] || {policies:{},category:category})
                    })
                    NiceData.fetchItemsFromFirebase(ref.child('policies')).then(policies => {
                        policies.forEach(policy => {
                            policy.templateName = template.text
                            if(this.menu.categories[policy.category])
                                this.$set(this.menu.categories[policy.category].policies, policy.name, policy)
                            
                        })
                    })
                    
                })
            })
        },

        loadTemplateOptions() {
            let templatesRef = DataHelpers.getRootRef().child('app/documentChecklist/list').orderByChild('template').equalTo(true)
            NiceData.fetchItemsFromFirebase(templatesRef).then(templates => {
                let templateOptions = templates.filter(o => o.tenantKey == this.tenantKey || o.global).map(o => { return{value: o.meta.key, text: o.name, order: o.order}})
                ArrayHelpers.findByName(this.checklistDetailsPanel.fields, 'templates').options = templateOptions
            })
        },
        logOpenedDate() {
            this.clients.forEach(client => {
                ContactHelpers.updateOpenedDate(client)
            })
        }
    },
    created () {

        

        DataHelpers.initialiseTenant(this.tenantKey)
        if(!this.checklistKey) {
            let key = DataHelpers.getKey()
            this.$router.push('/' + this.tenantKey + '/document-checklist/' + key)
        }

        this.loadDetails().then(checklist => {
            this.loadMenu()
        })


        this.loadTemplateOptions()

        

        //check for contacts existing (temporary)...

        console.log('document-checklist > created')
        let vm = this

        this.liveTransaction = {
            details:{},
            clients: []
        }

        this.setSpecialTab('checklist')

        this.$store.dispatch('loadTransaction', this.checklistKey).then((transaction) => {
            if(!transaction) {
                AlertHelpers.showAlert('Checklist is not linked to a transaction')
                return
            }
                
            Utilities.log('Workflow > initialise - Calling load transaction', transaction)
            vm.liveTransaction.details = transaction
            
            // Get contacts for transaction (new way)

            this.$store.dispatch('fetchElementsByType', 'Contact').then(contactElements => {

                console.log('celements', contactElements)
                let contacts = ElementHelpers.contactElementsForRole('Client', contactElements).map(o => {
                    return {
                        key: o.contactKey,
                        tenantKey: o.tenantKey,
                        ...o.contact
                    }
                    
                })
            
                if(contacts && contacts.length)
                    this.liveTransaction.clients = contacts

                this.logOpenedDate()
            
            })


            // Set up the follow up task
            ChecklistHelpers.fetchChecklistTask(this.tenantKey, this.checklistKey).then(task => {
                this.followUpTask = task
            })
            // const fupRef = DataHelpers.getTenantRef().child('tasks').orderByChild('transactionKey').equalTo(this.checklistKey)
            // FireData.fetchItems(fupRef).then(tasks => {
            //     let fupTask = tasks.find(o => o.code == 'document-checklist')
            //     if(fupTask)
            //         this.followUpTask = fupTask
            // })

            setTimeout( () => {
                
                if(!vm.clients.length)
                    AlertHelpers.showAlert("Old file: Please go into transaction, then add clients as contacts manually")

            },4000)

                
        }).catch(err => {
            Utilities.log('Created > Error in loadTransaction ', err)
            debugger
            AlertHelpers.showAlert('Error loading transaction')
        })

    }
}

</script>

<style scoped>


.hide-scroll {
    overflow: hidden;
}

.hide-scroll-inner {
    overflow: auto;
    margin-right: -100px;
    padding-right: 100px;
}

</style>


// WEBPACK FOOTER //
// DocumentChecklist.vue?0257453e